<template>
  <table v-if="headers" :id="Tableid" class="table table-bordered">
    <thead class="w3-light-grey">
      <tr>
        <th
          v-for="header in headers"
          :key="'header-' + header.key"
          class="size11 ellipsis"
          :class="header.class ?? ''"
          :title="header.text ?? ''"
        >
          {{ header.text }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in Rows" :key="row.uuid">
        <td
          v-for="header in headers"
          :key="'col-' + row.uuid + '-' + header.key"
          class="size13"
          :class="row[header.key]?.class ?? ''"
        >
          <span v-html="row[header.key]?.value"></span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import $ from "jquery";
import "datatables.net/js/jquery.dataTables.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";
import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import { v4 as uuid } from "uuid";
import { toRef, onMounted, onBeforeUpdate } from "vue";
export default {
  props: ["headers", "rows", "tableid"],
  setup(props) {
    const Tableid = toRef(props, "tableid");
    const Headers = toRef(props, "headers");
    const Rows = toRef(props, "rows");
    const Sort = toRef(props, "sort");

    for (let i = 0; i < Rows.value.length; i++) {
      Rows.value[i].uuid = uuid();
    }
    const TableId = Tableid.value ?? uuid();
    onBeforeUpdate(() => {
      $("#" + TableId)
        .DataTable()
        .clear()
        .destroy();
      // $("#" + TableId).empty();
    });
    onMounted(() => {
      $("#" + TableId).DataTable({
        responsive: true,
        order: Sort.value ?? [[0, "asc"]],
        dom: '<<"w3-left"l><"clear"><t>ip>',
      });
    });

    return {
      Tableid,
      Headers,
      Rows,
      uuid,
    };
  },
};
</script>
<style scoped>
input[readonly] {
  background-color: #fff;
}
</style>